import { HELIUM_LIMIT_MAX } from 'utils/constants';
import { type OpTableRecordType, type TableState } from '../OpTableCore/types';

// TODO - add the pre chars to the filters
export const createQueryStringParamsFromTableState = <
  T extends OpTableRecordType,
>({
  tableState,
  offsetForCsv,
  isUsingCursor = false,
}: {
  tableState: TableState<T>;
  offsetForCsv?: number;
  isUsingCursor?: boolean;
}) => {
  // Create the final filter string
  const finalFilter = Object.entries(tableState.filters)
    // Filter out any falsy values
    // Type is string so don't need to worry about 0
    .filter(([, value]) => value)
    // Values getting = prefix when created so don't need to add here
    .map(([key, value]) => `${key}:(${value})`)
    // Join each filter to make the filter string
    .join(' ');

  let limit;
  let offset;
  let sort;
  let order;
  let cursor;

  /** For CSV export we need to loop through to get all records needed
   * so we set the limit to the Helium max and then pass in increasing
   * offsets until we have all the records (or we use cursor pagination)
   *
   * We don't want to use sort and order when using cursor as we want
   * it to default sort by ID for performance reasons
   */

  if (isUsingCursor) {
    cursor = '';
  } else {
    if (typeof offsetForCsv === 'number') {
      limit = HELIUM_LIMIT_MAX;
      offset = offsetForCsv;
    } else {
      limit = tableState.pagination.pageSize;
      offset =
        (tableState.pagination.current - 1) * tableState.pagination.pageSize;
    }

    if (
      // Sorter can optionally be an array, so we need to type narrow
      !Array.isArray(tableState.sorter) &&
      tableState.sorter?.order
    ) {
      sort = tableState.sorter.columnKey;
      order = tableState.sorter.order === 'ascend' ? 'asc' : 'desc';
    }
  }

  return {
    // Only add items if they are defined
    ...(limit !== undefined && { limit }),
    ...(offset !== undefined && { offset }),
    ...(sort !== undefined && { sort }),
    ...(order !== undefined && { order }),
    ...(cursor !== undefined && { cursor }),

    // Only add filter if the final filter string has a value
    ...(finalFilter && { filter: finalFilter }),

    // Only add q if the param has a value
    ...(tableState.q && { q: tableState.q }),
  };
};
